import { openAuthPopup } from '@netlify/app-auth'
import { useEffect, useState } from 'react'

import DockButton from '~/components/DockButton'
import DockShareLink from '~/components/DockShareLink'
import Flex from '~/components/Flex'
import Image from '~/components/Image'
import Tool from '~/components/Tool'
import ToolGroup from '~/components/ToolGroup'
import { SESSION_STORAGE_KEY } from '~/helpers/auth'
import { ArrowRightIcon } from '~/icons/evergreen'
import { useActions, useStore } from '~/store/hooks'
import { messagePromise } from '~/utils/messages'
import { toggleDrawer } from '~/utils/toggles'

export default function DockStateLoggedOut() {
  const toggles = useStore(actions => actions.hud.toggles)
  const toggle = useActions(actions => actions.hud.toggle)

  const [deployType, setDeployType] = useState('Deploy Preview')

  const getDeployType = async () => {
    try {
      const origin = await messagePromise('LOCATION_ORIGIN', document.location.origin)
      const label = origin.startsWith('https://deploy-preview-') ? 'Deploy Preview' : 'branch deploy'
      if (label !== deployType) {
        setDeployType(label)
      }
    } catch (err) {
      // the sound of silence
    }
  }

  useEffect(() => {
    getDeployType()
  }, [])

  return (
    <>
      <Flex justifyContent="flex-start">
        <ToolGroup border="right">
          <Tool
            active={false}
            iconBefore={<Image alt="Logo" height={24} src="/img/logo/netlify.svg" width={24} />}
            label={
              <>
                Collaborate <span className="is-hidden-mobile">on this {deployType}</span>
              </>
            }
            // name="drawer"
            onClick={() => toggleDrawer(toggles, toggle)}
          />
        </ToolGroup>
        <ToolGroup>
          <Tool
            active={false}
            iconAfter={<ArrowRightIcon size={12} />}
            label={
              <>
                Log in <span className="is-hidden-mobile">to the Netlify Drawer</span>
              </>
            }
            // name="drawer"
            onClick={() =>
              openAuthPopup({
                url: '/auth/popup',
                popupWidth: 500,
                popupHeight: 728,
                storageKeyOverride: SESSION_STORAGE_KEY,
                // messages.ts handles the auth state
                // setting after getting a long-lived token
                manuallySetStorage: true,
              })
            }
          />
        </ToolGroup>
      </Flex>
      <Flex>
        <DockShareLink />
        <DockButton border="left" />
      </Flex>
    </>
  )
}
